import React from 'react';

export default () => (
    <svg viewBox="1 1 14 14" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M 1 11 C 1 10.448 1.448 10 2 10 L 4 10 C 4.552 10 5 10.448 5 11 L 5 14 C 5 14.552 4.552 15 4 15 L 2 15 C 1.448 15 1 14.552 1 14 Z M 11 7 C 11 6.448 11.448 6 12 6 L 14 6 C 14.552 6 15 6.448 15 7 L 15 14 C 15 14.552 14.552 15 14 15 L 12 15 C 11.448 15 11 14.552 11 14 Z M 6 2 C 6 1.448 6.448 1 7 1 L 9 1 C 9.552 1 10 1.448 10 2 L 10 14 C 10 14.552 9.552 15 9 15 L 7 15 C 6.448 15 6 14.552 6 14 Z"
            fill="currentColor"
        />
    </svg>
);
